import React from 'react';
import { PropTypes } from 'prop-types';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import Text from './styled';

const GenericCell = ({ rowInfo, showSkeleton, field }) => {
  const label = get(rowInfo, `original.value.${field}`, '');

  if (showSkeleton) return <Skeleton />;
  return (
    <Text>
      { label }
    </Text>
  );
};

GenericCell.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  showSkeleton: PropTypes.bool
};

GenericCell.defaultProps = {
  field: '',
  showSkeleton: false
};

export default GenericCell;
